import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import capitalize from '../../helpers/capitalize';
import shadow from '../../helpers/shadow';
import Link from '@mui/material/Link';
import Badge from '@mui/material/Badge';

const useStyles = makeStyles()(theme => ({
  listItem: {
    '&:hover': {
      backgroundColor: `${theme.palette.background.paper} !important`,
      borderRadius: 12,
      marginLeft: 5,
      width: 'calc(100% - 10px)',
      boxShadow: shadow.default,
    },
  },
  listItemSelected: {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    backgroundColor: `${theme.palette.background.paper} !important`,
    borderRadius: 12,
    boxShadow: shadow.md,
    marginLeft: 5,
    width: 'calc(100% - 10px)',
  },
  listItemText: {
    marginLeft: -15,
  },
}));

export default function DashboardMenuItem({
  page,
  link,
  active,
  open,
  Icon,
  iconComponent,
  title,
  unreadCount,
  isNoDashboard,
}) {
  const { classes } = useStyles();

  return (
    <>
      <Link
        color="textPrimary"
        href={
          isNoDashboard
            ? `${link !== undefined ? link : `/${page}`}?open=${open}`
            : `/dashboard${link !== undefined ? link : `/${page}`}?open=${open}`
        }
      >
        <ListItem
          selected={active === page}
          button
          classes={{
            root: classes.listItem,
            selected: classes.listItemSelected,
          }}
        >
          <ListItemIcon
            style={active === page ? { marginLeft: -5 } : undefined}
          >
            {iconComponent ? (
              iconComponent
            ) : unreadCount ? (
              <Badge badgeContent={unreadCount} color="primary">
                <Icon color={active === page ? 'primary' : undefined} />
              </Badge>
            ) : (
              <Icon color={active === page ? 'primary' : undefined} />
            )}
          </ListItemIcon>
          <ListItemText
            primary={title || capitalize(page)}
            className={classes.listItemText}
          />
        </ListItem>
      </Link>
    </>
  );
}
